import { getScreenSize } from '#pplx/frontend/analytics/browser.js';
import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { stripeClient } from '#pplx_generated/typespec/rest/stripe/client.js';
export const createCheckoutSession = async ({ request, reason, }) => {
    if (!BUILD_CAPABILITIES.payments)
        return undefined;
    const screen = getScreenSize();
    const headers = {
        'content-type': 'application/json',
        ...(screen ? { 'Screen-Dimensions': screen } : {}),
    };
    try {
        const { data, error, response } = await stripeClient.POST('/rest/stripe/checkout-session', reason, {
            body: {
                discount_code: request.discountCode,
                origin: request.origin,
                tier: request.tier,
                locale: request.locale,
                embedded: request.embedded ?? false,
                subscription_tier: request.subscriptionTier,
                success_redirect_url: request.success_redirect_url,
            },
            timeoutMs: 5000,
            headers,
            reason,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
                details: {
                    reason,
                },
            });
        }
        return {
            subscriptionStatus: data.subscription_status,
            status: data.status,
            url: data.url ?? null,
            clientSecret: data.client_secret ?? undefined,
            errorCode: data.error_code ?? undefined,
            subscriptionTier: request.subscriptionTier,
            tierDescription: data.tier_description ?? undefined,
        };
    }
    catch {
        return undefined;
    }
};
//# sourceMappingURL=createCheckoutSession.js.map